import axios from "axios";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Select from "react-select"
import { API_CONFIG, API_HEADERS } from "../../network/config/ApiConfig";
import { AUDIO_ROOM_API_PATH, USER_API_PATH } from "../../network/config/apiPaths";
function AddAlbumParticipents() {
    const navigate = useNavigate();
    const location = useLocation();
    const roomId = location.state != null ? location.state.roomId : "";
    const [participantList, setParticipantList] = useState([]);
    const [selectedIds, setSelectedIds] = useState([]);

    const handleCheckboxChange = (id, checked) => {
        if (checked) {
            setSelectedIds((prev) => [...prev, id]); // add id
        } else {
            setSelectedIds((prev) => prev.filter((pid) => pid !== id)); // remove id
        }
    };
    const [role, setRole] = useState(4);
    // const [participantId, setParticipantId] = useState("");
    // const [checkedStatus, setCheckedStatus] = useState(false)

    console.log("selected participants ids", selectedIds)
    console.log("role", role)

    useEffect(() => {
        UserList();
    }, [role])

    const UserList = async () => {

        const data = await axios.get(
            API_CONFIG.API_HOST + USER_API_PATH.LIST_PATH + role,
            {
                headers: API_HEADERS,
            }

        );

        console.log("users", data.data.result.data)
        if (data.data.result !== null) {

            setParticipantList(data.data.result.data)
        }
    };
    const onSubmit = async (aMap) => {
        let requestBody = {
            room_id: roomId,
            participant_id: selectedIds[0],
            action: aMap
        }
        let data = await axios.post(API_CONFIG.API_HOST + AUDIO_ROOM_API_PATH.PARTICIPANTS_MAPPING, requestBody, {
            headers: API_HEADERS
        })
        console.log("participant mapping result", data);
        data.status == 200 && navigate(-1)
    }

    // const mapUnMap = (id) => {
    //     setCheckedStatus(!checkedStatus)
    //     if (checkedStatus) {
    //         setParticipantId(id)
    //     }
    //     else {

    //     }

    // }

    return (
        <>
            <div
            // style={{
            //     position: "fixed",
            //     backgroundColor: "rgba(0,0,0,0.5)",
            //     width: "100%",
            //     height: "100%",
            //     zIndex: "999",
            //     overflow: "scroll",
            // }}
            >
                <div className="row m-5">

                    <h4 className="text-center">Add Participents</h4>
                    <div className="col-md-12">
                        <div className="row form-group">
                            {/* <label style={labelStyle}>Search City/Town</label>{" "} */}
                            {/* {inputValidation.place_address} */}
                            {/* <AutoComplete
                                                    className="form-control"
                                                    style={{ width: "100%" }}
                                                    name="city"
                                                    options={{
                                                        types: ["geocode", "establishment"],
                                                    }}
                                                    onChange={(e) => handleChange(e)}
                                                    value={inputvalidation.city}
                                                    apiKey={"AIzaSyCB14naEHjDiVBFLEqhPBMUA9eqg_4yRdk"}
                                                    onPlaceSelected={(place) => updatePlaceInfo(place)}
                                                    placeholder="Enter city name"
                                                />
     */}
                            <div className="col-4">
                                <label>Select Role</label>
                                <select className="form-control"
                                    value={role}
                                    onChange={(e) => { setRole(e.target.value) }}
                                >
                                    <option value={4}>PARTICIPANT</option>
                                    <option value={5}>USERS</option>
                                </select>
                            </div>
                            {
                                role == 4 ? <div className="col-4">
                                    <label>Category</label>
                                    <select className="form-control">
                                        <option>{"--Select Category--"}</option>
                                    </select>
                                </div> : ""
                            }
                            <div className="row mt-5">
                                <div className="col-4">
                                {participantList.length > 0 &&
                                    participantList.map((item) => (
                                        <div key={item.id}>
                                            <input
                                                type="checkbox"
                                                className="checkbox-margin"
                                                checked={selectedIds.includes(item.id)}
                                                onChange={(e) => handleCheckboxChange(item.id, e.target.checked)}
                                                style={{ marginRight: "10px" }}
                                            />
                                            {item.name}
                                        </div>
                                    ))}
                                    </div>
                            </div>
                            {/* <Select

                                                name="selectedTags"
                                                isMulti
                                                options={participantList}

                                                getOptionLabel={(option) => `${option.name}`}
                                                getOptionValue={(option) => `${option.id}`}
                                            onChange={(sOptions) => {
                                                let roomId = []
                                              
                                                sOptions.map(item => {roomId.push(item.id);setParticipantId(item.id)})
                                                // setSelectedIds(sOptions.id)
                                                // setSelectedTags(sOptions);
                                                // setSelectedIds(roomId)
                                            }} */}



                            {/* {
                                                    item.role_id === "7" ? <>
                                                        <label>Franchise owner</label>
                                                        {
                                                            SelectFranchiseOwner()
                                                        }
                                                    </> : ""
                                                } */}

                            {/* {item.role_id === "9" ? <>
                                                    <label>Franchise Percentage</label>
                                                    <input
                                                        type="number"
                                                        onChange={handleChange}
                                                        name="foShare"
                                                        value={inputvalidation.foShare}
    
                                                        className="form-control"
    
                                                    />
                                                </> : ""} */}

                            {/* {
                                                    item.role_id === "9" ?
                                                        <>
                                                            <label>Radius</label>
                                                            <input
                                                                type="number"
                                                                onChange={handleChange}
                                                                name="radius"
                                                                value={inputvalidation.radius}
    
    
                                                                className="form-control"
    
                                                            />
                                                        </> : ""
                                                } */}
                            {/* <label>Adhar Number</label>
                                                <input
                                                    type="number"
                                                    onChange={handleChange}
                                                    name="adhar"
                                                    value={inputvalidation.adhar}
                                                    className="form-control"
    
                                                />
                                                <label>PAN Number</label>
                                                <input
                                                    type="number"
                                                    onChange={handleChange}
                                                    name="pan"
                                                    value={inputvalidation.pan}
                                                    className="form-control"
    
                                                />
    
                                                <label>Driving License</label>
                                                <input
                                                    type="number"
                                                    onChange={handleChange}
                                                    name="license"
                                                    value={inputvalidation.license}
                                                    className="form-control"
    
                                                /> */}

                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    marginTop: 20,
                                }}
                            >
                                <button
                                    style={{ display: "flex", justifyContent: "center" }}
                                    type="button"
                                    className="btn btn-purple-bg"
                                    onClick={()=>onSubmit("MAP")}
                                >
                                    Submit
                                </button>

                                 <button
                                    style={{ display: "flex", justifyContent: "center",marginLeft:10 }}
                                    type="button"
                                    className="btn btn-danger"
                                    onClick={()=>onSubmit("UNMAP")}
                                >
                                    Delete
                                </button>

                                <button
                                    className="btn btn-white-bg"
                                    onClick={() => {
                                        // dispatch(
                                        //   updateFormInfo({
                                        //     displayForm: false,
                                        //     formData: {},
                                        //   })
                                        // );
                                        navigate(-1)
                                    }}
                                >
                                    Cancel
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


        </>
    );


}
export default AddAlbumParticipents